module.exports = __webpack_public_path__ + "static/media/all-fly.bd8e6530.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/all-fly.png
// module id = 1914
// module chunks = 6